import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

/* Pages */
import Home from "./pages/Home/HomePage";

import RouterScrollTop from "./components/ScrollToTop/RouterScrollTop";


function App() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });

    const refreshAos = () => AOS.refresh();
    window.addEventListener("load", refreshAos);
    // Recalc after React paint + late-loading images/fonts
    const refreshTimer = window.setTimeout(refreshAos, 500);

    return () => {
      window.removeEventListener("load", refreshAos);
      window.clearTimeout(refreshTimer);
    };
  }, []);

  return (
    <>
      <RouterScrollTop />

      <Routes>
        <Route path="/" element={<Home />}></Route>
      </Routes>
    </>
  );
}

export default App;
